<nb-card class="auto-recharge-dialog">
  <nb-card-header>
    <div>
      <h4>{{ "pages.organisation.credits.autoRecharge.dialog.title" | translate }}</h4>
    </div>
    <button nbButton ghost status="basic" size="small" type="button" (click)="close()">
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body>
    <p class="intro">
      {{ "pages.organisation.credits.autoRecharge.dialog.intro" | translate }}
    </p>

    <form [formGroup]="form">
      <div class="field">
        <label>{{ "pages.organisation.credits.autoRecharge.dialog.threshold" | translate }}</label>
        <nb-form-field>
          <span nbPrefix>€</span>
          <input nbInput fullWidth type="number" min="0" step="1" formControlName="threshold_eur" />
        </nb-form-field>
      </div>

      <div class="field">
        <label>{{ "pages.organisation.credits.autoRecharge.dialog.amount" | translate }}</label>
        <nb-form-field>
          <span nbPrefix>€</span>
          <input nbInput fullWidth type="number" [min]="settings?.min_purchase_eur ?? 10" step="1" formControlName="amount_eur" />
        </nb-form-field>
      </div>

    </form>
  </nb-card-body>

  <nb-card-footer>
    <span class="charge-note">
      {{ "pages.organisation.credits.autoRecharge.dialog.chargeNote" | translate }}
    </span>
    <div class="actions">
      <button *ngIf="!enabling" nbButton status="basic" type="button" (click)="disable()">
        {{ "pages.organisation.credits.autoRecharge.dialog.disable" | translate }}
      </button>
      <button nbButton status="primary" type="button" [disabled]="form.invalid" (click)="save()">
        {{
          (enabling
            ? "pages.organisation.credits.autoRecharge.dialog.activate"
            : "pages.organisation.credits.autoRecharge.dialog.update"
          ) | translate
        }}
      </button>
    </div>
  </nb-card-footer>
</nb-card>
